import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { resetPassword } from '../../services/auth';
import '../LoginPage/LoginPage.css';

const ResetPasswordPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.newPassword.length < 8) {
      setError('Новый пароль должен быть не короче 8 символов');
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError('Новые пароли не совпадают');
      return;
    }

    setIsSubmitting(true);

    try {
      await resetPassword(token, formData.newPassword);
      navigate('/login', {
        replace: true,
        state: { successMessage: 'Пароль успешно изменен' },
      });
    } catch {
      setError('Ссылка недействительна или истекла');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-container auth-page">
      <div className="login-card">
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <input
              type="password"
              name="newPassword"
              placeholder="Новый пароль"
              value={formData.newPassword}
              onChange={handleInputChange}
              className="login-input"
              minLength={8}
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              name="confirmPassword"
              placeholder="Подтвердите новый пароль"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              className="login-input"
              minLength={8}
            />
          </div>

          {error && (
            <div className="auth-message auth-message--error">
              {error}
            </div>
          )}

          <button type="submit" className="login-btn" disabled={isSubmitting}>
            {isSubmitting ? 'Сохранение…' : 'Сохранить пароль'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
